export function initHeaderMenu()
{
    if (!window.jQuery) {
        return;
    }

    const $ = window.jQuery;
    const isDesktop = $(window).width() > 767;

    $('.header-menu a.icon-menu').off('.sbHeader');
    $('.close-arrow-menu').off('.sbHeader');
    $('.header-contact a').off('.sbHeader');
    $('.close-arrow-contact').off('.sbHeader');

    if (isDesktop) {
        $('.header-menu a.icon-menu').on('click.sbHeader', function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            $('nav.menu').slideDown('slow');
            $('header').addClass('hide-head');
        });

        $('.close-arrow-menu').on('click.sbHeader', function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            $('nav.menu').slideUp('slow');
            $('header').removeClass('hide-head');
        });

        return;
    }

    $('.header-contact a').removeAttr('data-target');

    $('.header-contact a').on('click.sbHeader touchstart.sbHeader', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        $('nav.contact').addClass('active');
        $('.header-contact a.close-arrow-contact').toggle();
        $(this).toggle();
        $('header').addClass('hide-head');
    });

    $('.close-arrow-contact').on('click.sbHeader touchstart.sbHeader', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        $('nav.contact').removeClass('active');
        $('.header-contact a:not(.close-arrow-contact)').show();
        $(this).hide();
        $('header').removeClass('hide-head');
    });

    $('.header-menu a.icon-menu').on('click.sbHeader touchstart.sbHeader', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        $('nav.menu').addClass('active');
        $(this).hide();
        $('.header-menu a.close-arrow-menu').toggle();
        $('header').addClass('hide-head');
    });

    $('.close-arrow-menu').on('click.sbHeader touchstart.sbHeader', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        $('nav.menu').removeClass('active');
        $('.header-menu a.icon-menu').show();
        $(this).hide();
        $('header').removeClass('hide-head');
    });
}
